import { snakeCase, startCase, toLower } from 'lodash'
import axios from '../../../utils/http/axios-local'
import { EvidenceRule, TemplateDTO } from '../dto/template'
import { NONE_MERCHANT } from '../context/merchant-context'

export const putTemplate = (templateId: number, data: Partial<TemplateDTO>) => {
  const url = `/det/tooling/templates/${templateId}`
  return axios.put(url, data)
}

export const patchToggleActive = (templateId: number, isActive: boolean) => {
  let url = `/det/tooling/templates/${templateId}/`
  if (isActive) {
    url += 'enable'
  } else {
    url += 'disable'
  }
  return axios.patch(url)
}

export const createNewTemplate = (
  originTemplate: TemplateDTO,
  data: Partial<TemplateDTO>
) => {
  const url = `/det/tooling/templates/sub_templates`

  const dataToPass = {
    template: {
      portal_id: originTemplate.portal.id,
      name: snakeCase(data.name),
      display_name: data.name,
      merchant_id: originTemplate.merchantId
    }
  }
  return axios.post(url, dataToPass)
}

export const postEvidenceRules = (rules: EvidenceRule, isNew: boolean) => {
  let url = `/det/tooling/evidence_rules`
  if (!isNew) {
    url += `/${rules.id}`
  }
  const request = isNew ? axios.post : axios.put
  return request<EvidenceRule>(url, rules)
}

export const generateJsonLogic = (description: string) => {
  const url = `/det/tooling/evidence_rules/resolve_rulesets?prompt=${description}`

  return axios.get(url)
}

export const deleteTemplate = (id: number, isGpd: boolean) => {
  if (isGpd) {
    return axios.delete(`/det/tooling/templates/${id}`)
  } else {
    return axios.patch(`/det/tooling/templates/${id}/delete`)
  }
}

export const changeTemplateHiddenStatus = (id: number, merchantId: number) => {
  let url = `/det/tooling/templates/${id}/toggle_hidden`
  if (merchantId && merchantId !== NONE_MERCHANT.id) {
    url += `?merchant_id=${merchantId}`
  }
  return axios.patch<{ id: number }>(url)
}

export const changeTemplateRenderingExcludedStatus = (
  id: number,
  merchantId: number
) => {
  let url = `/det/tooling/templates/${id}/toggle_rendering_excluded`
  if (merchantId && merchantId !== NONE_MERCHANT.id) {
    url += `?merchant_id=${merchantId}`
  }
  return axios.patch<{ id: number }>(url)
}

export const callOverrideTemplate = (
  template: TemplateDTO,
  merchantId: number
) => {
  return axios.post(`/det/tooling/templates/merchant_override`, {
    template: { id: template.templateId, merchant_id: merchantId }
  })
}

export const getTemplateDisplayName = (template: TemplateDTO): string => {
  if (template.displayName) {
    return template.displayName
  }

  return startCase(toLower(template.name?.replace(/_/g, ' ') ?? ''))
}
